import AddTestStepper from "../../components/add/AddTestStepper";
import { Box, Button, TextField } from "@mui/material";
import AddTestPageNavButtons from "./AddTestPageNavButtons";
import React, { useContext } from "react";
import { VideoContext } from "../../context/video_context";

type RunTest = {
  handlePageChangeUp: any;
  handlePageChangeDown: any;
  handlePageChange: any;

};

const activeStep: number = 4;

export default function RunTest(fn: RunTest) {
  const videoContext = useContext(VideoContext);
  const createTest = videoContext?.createTest;
  React.useEffect(() => {
    createTest?.();
  },[]);
  return (
    <Box
      sx={{
        width: "100%",
        paddingY: "20px",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <AddTestStepper activeStep={activeStep} />
      <Box sx={{ paddingX: "100px", paddingY: "20px" }}>
        <Box sx={{ fontSize: "h2.fontSize", paddingY: "20px" }}>
          Your Test is Running!
        </Box>
      </Box>
      <AddTestPageNavButtons
        step={activeStep}
        handlePageChangeUp={fn.handlePageChangeUp}
        handlePageChangeDown={fn.handlePageChangeDown}
      />
    </Box>
  );
}
